export enum RequirementName {
  LocationAccess = 'LocationAccess',
  LocationManager = 'LocationManager',
  LocationOrganizationOwner = 'LocationOrganizationOwner',
  LocationTenantAdministrator = 'LocationTenantAdministrator',
  OrganizationAccess = 'OrganizationAccess',
  OrganizationOwner = 'OrganizationOwner',
  OrganizationTenantAdministrator = 'OrganizationTenantAdministrator',
  TenantAdministrator = 'TenantAdministrator',
}

export const PermissionDefinitions = {
  location: {
    get: (id: string | number | null) => generateLocationPolicy(id, RequirementName.LocationManager),
    create: () => generateOrganizationPolicy(RequirementName.OrganizationOwner),
    edit: () => generateOrganizationPolicy(RequirementName.OrganizationOwner),
    delete: () => generateOrganizationPolicy(RequirementName.OrganizationOwner),
  },
  calendar: {
    getAll: () => generateOrganizationPolicy(RequirementName.OrganizationOwner),
  },
  provider: {
    get: (id: string | number) => generateLocationPolicy(id, RequirementName.LocationManager),
    // create: (id: string | number | null) => generateLocationPolicy(id, RequirementName.LocationManager),
    create: (id: string | number) => generateTenantPolicy(id, RequirementName.TenantAdministrator),
    edit: (id: string | number) => generateLocationPolicy(id, RequirementName.LocationManager),
    delete: (id: string | number) => generateLocationPolicy(id, RequirementName.LocationManager),
  },
  providerService: {
    get: (id: string | number) => generateLocationPolicy(id, RequirementName.LocationManager),
    create: (id: string | number) => generateLocationPolicy(id, RequirementName.LocationManager),
    edit: (id: string | number) => generateLocationPolicy(id, RequirementName.LocationManager),
    delete: (id: string | number) => generateLocationPolicy(id, RequirementName.LocationManager),
  },
  serviceType: {
    get: (id: string | number) => generateTenantPolicy(id, RequirementName.TenantAdministrator),
    create: (id: string | number) => generateTenantPolicy(id, RequirementName.TenantAdministrator),
    edit: (id: string | number) => generateTenantPolicy(id, RequirementName.TenantAdministrator),
    delete: (id: string | number) => generateTenantPolicy(id, RequirementName.TenantAdministrator),
  },
  service: {
    get: (id: string | number) => generateLocationPolicy(id, RequirementName.LocationManager),
    create: (id: string | number) => generateTenantPolicy(id, RequirementName.TenantAdministrator),
    edit: () => generateOrganizationPolicy(RequirementName.OrganizationOwner),
    delete: () => generateOrganizationPolicy(RequirementName.OrganizationOwner),
  },
  organization: {
    get: (id: string | number) => generateTenantPolicy(id, RequirementName.TenantAdministrator),
    create: (id: string | number) => generateTenantPolicy(id, RequirementName.TenantAdministrator),
    edit: (id: string | number) => generateTenantPolicy(id, RequirementName.TenantAdministrator),
    delete: (id: string | number) => generateTenantPolicy(id, RequirementName.TenantAdministrator),
  },
  user: {
    get: (id: string | number) => generateLocationPolicy(id, RequirementName.LocationManager),
    create: (id: string | number) => generateTenantPolicy(id, RequirementName.TenantAdministrator),
    edit: (id: string | number) => generateTenantPolicy(id, RequirementName.TenantAdministrator),
    delete: (id: string | number) => generateTenantPolicy(id, RequirementName.TenantAdministrator),
  },
  access: {
    get: (id: string | number) => generateTenantPolicy(id, RequirementName.TenantAdministrator),
    create: (id: string | number) => generateTenantPolicy(id, RequirementName.TenantAdministrator),
    edit: () => generateOrganizationPolicy(RequirementName.OrganizationOwner),
    delete: () => generateOrganizationPolicy(RequirementName.OrganizationOwner),
    locationRoles: () => generateOrganizationPolicy(RequirementName.OrganizationOwner),
    orgRoles: (id: string | number) => generateTenantPolicy(id, RequirementName.TenantAdministrator),
  },
  host: {
    get: (id: string | number) => generateSystemAdministratorPolicy(),
    create: () => generateSystemAdministratorPolicy(),
    edit: (id: string | number) => generateTenantPolicy(id, RequirementName.TenantAdministrator),
    delete: (id: string | number) => generateTenantPolicy(id, RequirementName.TenantAdministrator),
  }
};

// #region Policy String Generators
const separator = '|';

const generateSystemAdministratorPolicy = (): string => {
  return 'SystemAdministrator';
};

const generateTenantPolicy = (
  idParameterName: string | number,
  requirementName: string
): string => {
  return `Tenant${separator}${idParameterName}${separator}${'Inline'}${separator}${requirementName}`;
};

const generateOrganizationPolicy = (
  requirementName: string
): string => {
    return `Organization${separator}${separator}${'None'}${separator}${requirementName}`
};

const generateLocationPolicy = (
  idParameterName: string | number | null,
  requirementName: string
): string => {
  if(idParameterName == null)
    return `Location${separator}${separator}${'None'}${separator}${requirementName}`
  else
  return `Location${separator}${idParameterName}${separator}${'Inline'}${separator}${requirementName}`;
};
// #endregion

export {
  generateSystemAdministratorPolicy,
  generateTenantPolicy,
  generateOrganizationPolicy,
  generateLocationPolicy,
};
